import { STATUS } from "./mediaUpload";

export const VIDEO_MESSAGE_STATE = Object.freeze({
  EMPTY: "empty",
  SENT: "sent",
  PROCESSING: "processing",
  LOCKED: "locked",
  CLOSED: "closed",
  CANCELLED: "cancelled",
  FAILED: "failed",
});

const S = VIDEO_MESSAGE_STATE;

const hasVideo = ({ item }) => Boolean(item.videoMessageUrl);

const signingStarted = ({ item }) =>
  Boolean(item.signed) ||
  (item.fulfillers ?? []).some((fulfiller) => Boolean(fulfiller.fulfilled));

const RULES = [
  [({ item }) => Boolean(item.cancelled), S.CANCELLED],
  [({ item }) => Boolean(item.videoMessageProcessing), S.PROCESSING],
  [(view) => signingStarted(view) && hasVideo(view), S.LOCKED],
  [signingStarted, S.CLOSED],
  [
    (view) => view.outcome?.status === STATUS.FAILED && !hasVideo(view),
    S.FAILED,
  ],
  [hasVideo, S.SENT],
];

const RECORDABLE = new Set([S.EMPTY, S.SENT, S.FAILED]);

const stateOf = (view) =>
  RULES.find(([matches]) => matches(view))?.[1] ?? S.EMPTY;

export const videoMessageView = ({ item, outcome = null }) => {
  const state = stateOf({ item, outcome });

  return {
    state,
    canWatch: hasVideo({ item }),
    canRecord: RECORDABLE.has(state),
  };
};
